'use client';

import React, { FC, useCallback } from 'react';
import { Button } from 'components/ui/button';
import { useTracking } from 'app/_tracking';
import { GetSocialIcon, SocialType } from 'utils/icons';


type SocialButtonProps = {
  iconName: SocialType;
  link: string;
  iconSize?: number;
};


export const SocialButton: FC<SocialButtonProps> = (props) => {
  const {
    iconName,
    link,
    iconSize = 18
  } = props;
  const { trackEvent } = useTracking();

  const openLink = useCallback((iconName: SocialType) => {
    trackEvent({
      name: 'cv_social_link_clicked',
      properties: {
        link_name: iconName
      }
    });
    window.open(link, '_blank');
  }, [link, trackEvent]);

  return (
    <Button className='p-0' variant='nakedGrayLink' onClick={() => openLink(iconName)}>
      {GetSocialIcon(iconName, iconSize)}
    </Button>
  );
};
